/* eslint-disable @typescript-eslint/no-deprecated */

import React, { useState } from 'react'
import styled, { useTheme } from 'styled-components'
import { Poll, Ballot, Breakpoint, Text, timestampToDate, Button } from '@tumelo/shared'
import { ChatIcon, Stack } from '@tumelo/designsystem'
import { SingleQuestionStyles } from '../../SingleQuestion/SingleQuestion'
import { ResultsDue } from '../../ResultsDue/ResultsDue'
import { VoteCommentForm } from '../../VoteCommentForm'
import { useAnalytics } from '../../../application/analytics'
import { buildEvent } from '../../../application/analytics/eventBuilders'

interface Props {
  poll: Poll
  ballot: Ballot
  onClick: () => void
}

export const PollCompleted: React.FC<Props> = ({ poll, onClick, ballot }) => {
  const { colors } = useTheme()
  const { trackEvent } = useAnalytics()
  const [showForm, setShowForm] = useState(false)
  const toggleForm = () => {
    trackEvent(buildEvent.clickReasonToVote())
    setShowForm(!showForm)
  }

  return (
    <Container>
      <Title>Congratulations!</Title>
      <Subtitle>Your vote preference has been submitted to your fund managers.</Subtitle>
      {(showForm || ballot.comment) && <VoteCommentForm ballot={ballot} />}
      <Stack flexDirection={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}>
        {!showForm && !ballot.comment && (
          <VoteCommentFormButton>
            <Button
              icon={<ChatIcon fill={colors.secondary.medium} />}
              size="medium"
              inverse
              color={colors.dark}
              onClick={toggleForm}
            >
              Reason for voting?
            </Button>
          </VoteCommentFormButton>
        )}
      </Stack>
      <Border />
      <Footer>
        <ResultsDue
          endDate={timestampToDate(poll.relationships.generalMeeting.date)}
          resultsText="The final result will be available after the company AGM."
        />
        <Column>
          <Button size="medium" color={colors.dark} inverse onClick={onClick}>
            See all &apos;Open votes&apos;
          </Button>
        </Column>
      </Footer>
    </Container>
  )
}

const { MARGIN, MAX_WIDTH } = SingleQuestionStyles

const Container = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: ${Breakpoint.mobile}) {
    margin: ${MARGIN}rem 0 0 0;
  }
`

const VoteCommentFormButton = styled.div`
  display: flex;
  align-items: flex-start;
  margin-right: 2.5rem;
`

const Title = styled(Text)`
  font-weight: bold;
  margin-bottom: 0.5rem;
`

const Border = styled.div`
  margin: ${MARGIN}rem 0;
  margin-top: 3rem;
  border-bottom: 0.1rem ${({ theme }) => theme.colors.grey.light} solid;
`

const Footer = styled.div`
  display: flex;
  max-width: ${MAX_WIDTH}px;
  justify-content: space-between;

  @media (max-width: ${Breakpoint.tablet}) {
    flex-direction: column;
  }
`

const Column = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

const Subtitle = styled(Text)`
  margin-bottom: 3rem;
`
